import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import React, { useContext } from 'react';
import { classNames } from '../_common/defaultImports';
import { forwardRef } from '../helpers';
// eslint-disable-next-line no-redeclare
const SegmentedControlContext = 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
React.createContext(null);
const useSelectorContext = () => {
    const context = useContext(SegmentedControlContext);
    if (context === null) {
        throw new Error('SegmentedControl used without context');
    }
    return context;
};
const SegmentedControlComponent = forwardRef(function SegmentedControlComponent({ size = 'large', hasOnlyIcons = false, children, selected, onChange, as, className, style, isFloating, htmlAttributes, }, ref) {
    const classes = classNames('ndl-segmented-control', className, {
        'ndl-small': size === 'small',
        'ndl-large': size === 'large',
        'ndl-floating': isFloating,
    });
    const Component = as || 'div';
    return (_jsx(Component, Object.assign({ className: classes, style: style, role: "group", ref: ref }, htmlAttributes, { children: _jsx(SegmentedControlContext.Provider, { value: { onChange, selected, hasOnlyIcons }, children: children }) })));
});
SegmentedControlComponent.displayName = 'SegmentedControl';
const SegmentedControlItem = React.forwardRef(function SegmentedControlItem({ as, children, className, style, value, htmlAttributes, }, ref) {
    const { onChange, selected, hasOnlyIcons } = useSelectorContext();
    const isSelected = value && value === selected;
    const baseClasses = classNames(className, {
        'ndl-segment-item': !hasOnlyIcons,
        'ndl-segment-icon': hasOnlyIcons,
        'ndl-current': value && value === selected,
    });
    const Component = as || 'button';
    return (_jsx(Component, Object.assign({ onClick: () => !isSelected && onChange(value), className: baseClasses, style: style, ref: ref }, htmlAttributes, { children: children })));
});
SegmentedControlItem.displayName = 'SegmentedControl.Item';
// Issue with TypeScript forwardRef and subcomponents: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-894053907
const SegmentedControl = Object.assign(SegmentedControlComponent, {
    Item: SegmentedControlItem,
});
export { SegmentedControl };
//# sourceMappingURL=SegmentedControl.js.map